import {createCoreSagas} from '../../../redux/factories/crud/createSagas';
import {normalizeResponse} from '../../../redux/factories/helper';
import {actions, actionTypes} from './user.reducers';
import {apiClient} from '../../../shared/api';
import {call, put} from 'redux-saga/effects';
import {notifyError, notifySuccess} from "../../../shared/notificationUtils";
import {solveDownloadResponse} from "../../ui/components/AppMenu/redux/utils";

// list users in corporate
function* listUserOption({payload}) {
    let params = {};

    if (payload) {
        const {corporate_id} = payload;
        params = {corporate_id}
    }
    let response = yield call(apiClient.list, 'api/v2/users/options', undefined, undefined, undefined, params);

    if (response.error) {
        yield put(actions['listUserOptionFailed'](response.detail));
        yield call(notifyError, response.detail);
    } else {
        response = response.data;
        response.forEach(normalizeResponse);
        yield put(actions['listUserOptionSuccess'](response));
    }
}

function* listUserShareOption() {
    let response = yield call(apiClient.list, 'api/v2/users/share-options');

    if (response.error) {
        yield put(actions['listUserShareOptionFailed'](response.detail));
    } else {
        response = response.data;
        response.forEach(normalizeResponse);
        yield put(actions['listUserShareOptionSuccess'](response));
    }
}

function* downloadUsers({payload}) {
    let response = yield call(apiClient.post, 'report-service/api/v2/report/export-users', payload);
    if (response.error) {
        yield put(actions['downloadUsersFailed'](response.detail));
        yield call(notifyError, response.detail);
    } else {
        solveDownloadResponse(response);
        yield call(notifySuccess, 'Successfully download users list');
        yield put(actions['downloadUsersSuccess'](response));
    }
}

export const userCoreSaga = createCoreSagas([
    {
        type: actionTypes['listUserOption'],
        callback: listUserOption,
    },
    {
        type: actionTypes['listUserShareOption'],
        callback: listUserShareOption,
    },
    {
        type: actionTypes['downloadUsers'],
        callback: downloadUsers,
    },
]);

